import React from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SearchPanel from '@/modules/articles/components/search/search-panel';
import { WidgetHost, NewsWidget } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';

export class SearchWidget implements NewsWidget {
  defaultTitle = 'Search';

  readonly id = '/search';

  initialize(host: WidgetHost) {}

  async hasPermission(permissions: string[]) {
    return true;
  }
  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faSearch} /> Search
      </>
    );
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get shortTitle(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faSearch} />
      </>
    );
  }

  get mainPanel(): JSX.Element {
    return <SearchPanel />;
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '',
        element: <SearchPanel />,
      },
    ];
  }

  get defaultRoute(): string {
    return '';
  }
}
